<template>
    <div class="modal fade modal-upload" id="editDOC" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">

                <div v-show="(loading == true)" class="loading-backdrop">
                    <div class="loading"></div>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                    <form class="" @submit.prevent="editDOC">
                        <div class="center-modal ex-input-center">
                            <div class="center-ttl text-center">
                                {{ $t('doc.edit.title') }}
                            </div>

                            <div class="error-message" v-if="alert_error" data-vv-scope='s1'>
                                <div class="d-flex">
                                    <i class="icon-warning mr-2"></i>
                                    <div class="errror-txt">
                                        <p class="fs-14 text-red font600">{{ $t('error.title') }}</p>
                                        <p class="fs-14 text-red font600">{{ alert_error }}</p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="this.editObj.ids.length == 1" data-vv-scope='s2'>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('doc.general.connection') }} <span class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('connection') }">
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            name="connection"
                                            key="connection"
                                            v-model="doc.connection"
                                            class="form-control"
                                            :placeholder="$t('place_holder.connection')"
                                            :data-vv-as="$t('doc.general.connection')"
                                            v-validate.disable="'required|url'">
                                        <div v-show="errors.has('connection')" class="error-text">{{ errors.first('connection') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('doc.general.login_id') }} <span class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('loginId') }">
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            name="loginId"
                                            key="loginId"
                                            v-model="doc.loginId"
                                            class="form-control"
                                            :placeholder="$t('place_holder.login_id')"
                                            :data-vv-as="$t('doc.general.login_id')"
                                            v-validate.disable="'required|min:1|max:255'">
                                        <div v-show="errors.has('loginId')" class="error-text">{{ errors.first('loginId') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('doc.general.login_pw') }} <span class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('loginPw') }">
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            name="loginPw"
                                            key="loginPw"
                                            v-model="doc.loginPw"
                                            class="form-control"
                                            :placeholder="$t('place_holder.login_pw')"
                                            :data-vv-as="$t('doc.general.login_pw')"
                                            v-validate.disable="'required|min:1|max:255'">
                                        <div v-show="errors.has('loginPw')" class="error-text">{{ errors.first('loginPw') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('doc.general.start_date') }}
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('start_date') }">
                                       <date-picker
                                            ref="start_date"
                                            name="start_date"
                                            key="start_date"
                                            :placeholder="$t('place_holder.start_date')"
                                            :data-vv-as="$t('doc.general.start_date')"
                                            v-validate.disable="'date_format:yyyy.MM.DD'"
                                            format="YYYY.MM.DD"
                                            v-model="doc.start"
                                            :disabled-date="notBeforeDate"
                                            :editable="false"
                                            @change="changeDate">
                                       </date-picker>
                                       <div v-show="errors.has('start_date')" class="error-text">{{ errors.first('start_date') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('doc.general.end_date') }}
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('end_date') }">
                                       <date-picker
                                            ref="end_date"
                                            name="end_date"
                                            key="end_date"
                                            :placeholder="$t('place_holder.end_date')"
                                            :data-vv-as="$t('doc.general.end_date')"
                                            v-validate.disable="'date_format:yyyy.MM.DD'"
                                            format="YYYY.MM.DD"
                                            v-model="doc.end"
                                            :disabled-date="notBeforeDate"
                                            :editable="false"
                                            @change="changeDate">
                                       </date-picker>
                                       <div v-show="errors.has('end_date')" class="error-text">{{ errors.first('end_date') }}</div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center mt-4 pt-4">
                                    <div class="pr-2 w-165">
                                        <button class="btn btn-pink-53 w-100" type="submit" :disabled="submitted">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>

                                    <div class="pl-2 w-165">
                                        <button class="btn btn-gray-53 w-100" data-dismiss="modal" type="button" :disabled="submitted">
                                            {{ $t('button.cancel') }}
                                        </button>
                                    </div>
                                </div>

                            </div>

                            <div v-else>
                                <div class="">
                                    {{ $t('doc.general.no_select') }}
                                </div>

                                <div class="d-flex justify-content-center mt-4 pt-4">
                                    <div class="pl-2 w-165">
                                        <button class="btn btn-pink-53 w-100" data-dismiss="modal" type="button">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* global $ */
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ja';

import DOCManagementService from '@/services/admin/doc.service';
import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';
import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';
import store from '@/store/index';

export default {
    components: {
        DatePicker,
    },
    name: 'EditDOCManagement',
    props: {
        editObj: [Object],
        docObj: [Object],
    },
    data () {
        return {

            alert_success: "",
            alert_error: "",

            loading: false,
            submitted: false,

            doc: {
                connection: "",
                loginId: "",
                loginPw: "",
                start: "",
                end: "",
            },
        };
    },
    beforeCreate () {
        this.$forceUpdate();
    },
    created () {
        this.resetModal();
    },
    beforeMount () {
    },
    mounted () {
        let _this = this;
        $("#editDOC").on('show.bs.modal', function () {
            _this.detailDOC();
            store.commit('loading', false);
        });
        $("#editDOC").on('hide.bs.modal', function () {
            _this.resetModal();
            // _this.$emit('unSlectAllDOC');
            store.commit('loading', false);
        });
    },
    computed: {
    },
    watch: {
    },
    methods: {
        resetModal: function resetModal () {
            this.doc = {
                connection: "",
                loginId: "",
                loginPw: "",
                start: "",
                end: "",
            };

            this.alert_success = "";
            this.alert_error = "";
            this.loading = false;
            this.submitted = false;
            this.$validator.reset();
        },

        editDOC (e) {
            if (this.editObj.ids.length < 0) {
                return false;
            }

            Utils.trimObject(this.doc);

            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (!DateUtils.compareDate(this.doc.start, this.doc.end)) {
                    this.$validator.errors.add({
                        field: 'start_date',
                        msg: this.$t('error.error_before_date', { date: this.$t('doc.general.start_date') }),
                    });
                } else {
                    this.errors.remove("start_date");
                    this.errors.remove("end_date");
                }

                if (!valid || !DateUtils.compareDate(this.doc.start, this.doc.end)) {
                    this.submitted = false;
                    return false;
                }

                this.loading = true;

                DOCManagementService.editDOC(this.editObj.ids, this.doc)
                    .then(response => {
                        if (response.status == 423) {
                            StorageService.saveExpired();
                            AuthService.doLogout();
                        }
                        if (response.status == 200) {
                            this.alert_success = this.$t('success.update_success');
                            this.alert_error = "";
                            this.$toasted.success(this.alert_success, {icon: 'fa-check'});
                            this.$emit('updateListDOC');
                            this.$emit('unSlectAllDOC');

                            $('#editDOC').modal('hide');
                            $('.modal-backdrop').remove();
                        } else {
                            this.alert_success = "";
                            this.alert_error = this.$t('fail.update_fail');

                            let errorCode = Utils.getErrorCode(response);
                            if (errorCode) {
                                this.alert_error = this.$t('error.error_code_' + errorCode);
                            }

                            // this.$toasted.error(this.alert_error, {icon: 'fa-exclamation-triangle'});
                        }

                        if (response.status == 403) {
                            this.alert_success = "";
                            this.alert_error = this.$t('error.error_' + response.status);
                        }

                        this.loading = false;
                        this.submitted = false;
                        this.$validator.reset();
                    }).catch(error => {
                        this.alert_success = "";
                        this.alert_error = this.$t('fail.update_fail');

                        // $('#editDOC').modal('hide');
                        // $('.modal-backdrop').remove();
                        // this.$toasted.error(this.alert_error, {Icon: 'fa-exclamation-triangle'});

                        this.loading = false;
                        this.submitted = false;
                        this.$validator.reset();
                    });
            });
        },

        detailDOC: function detailDOC () {
            this.doc.connection = this.docObj.connection;
            this.doc.loginId = this.docObj.loginId;
            this.doc.loginPw = this.docObj.loginPw;

            if (!Utils.isEmptyStr(this.docObj.start)) {
                this.doc.start = new Date(this.docObj.start);
            } else {
                this.doc.start = "";
            }

            if (!Utils.isEmptyStr(this.docObj.end)) {
                this.doc.end = new Date(this.docObj.end);
            } else {
                this.doc.end = "";
            }
        },

        notBeforeDate (date) {
            let today = new Date();
            today.setDate(new Date().getDate() - 1);
            return date <= today;
        },

        changeDate (date) {
            /*
                this.errors.remove("start_date");
                this.errors.remove("end_date");

                if(!Utils.compareDate(this.doc.start, this.doc.end)) {
                    this.$validator.errors.add({
                      field: 'start_date',
                      msg: this.$t('error.error_before_date', { date: this.$t('doc.general.start_date')})
                    });
                }
                */
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/DOCManagement/Edit.vue